import { render, staticRenderFns } from "./VcaToolboxes.vue?vue&type=template&id=00917c4f&scoped=true"
import script from "./VcaToolboxes.vue?vue&type=script&lang=js"
export * from "./VcaToolboxes.vue?vue&type=script&lang=js"
import style0 from "./VcaToolboxes.vue?vue&type=style&index=0&id=00917c4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00917c4f",
  null
  
)

export default component.exports